import { useEffect, useState } from "react";
import { connect } from 'react-redux';
import { useHistory } from "react-router-dom";

import DropnGoDashboardCard from "../../admin/components/report/DropNGoDashboardCard";
import Sidebar from "./components/Sidebar";
import Topbar from "./components/Topbar";

const DropnGoDashboard = ({ token, distributor }) => {

    const history = useHistory();

    const [toggled, setToggled] = useState(false)

    useEffect(() => {
        if (!distributor || !distributor.dropngo_dashboard) {
            history.push('/distributor')
        }
    }, [])

    const handleToggle = () => {
        setToggled(!toggled);
    }

    return (
        <div className="admin-page-container">
            <Sidebar toggled={toggled} setToggled={handleToggle} />
            <div className="admin-page">
                <Topbar handleToggle={handleToggle} />

                <div className="admin-content">
                    <DropnGoDashboardCard
                        token={token}
                    />
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = state => {
    return {
        distributor: state.distributor.distributor,
        token: state.distributor.token
    };
};

export default connect(mapStateToProps, null)(DropnGoDashboard);